export const SectionHead = ({ nr, label, right = "Norwegian AI Summit · 2027", testid }) => (
  <div className="ns-head" data-rv data-testid={testid}>
    <span><b>{nr}</b>{label}</span>
    <span>{right}</span>
  </div>
);
